var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"contact"},[_c('div',[_c('div',{staticClass:"conact-header-image"},[_c('img',{staticClass:"conact-image",attrs:{"src":_vm.kefuImage}})]),_c('div',{staticClass:"tip"},[_vm._v("扫描图片，添加客服微信")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }